import {defineStore} from 'pinia';
import {add, isAfter, sub} from 'date-fns';
import {useUserStore} from '~/modules/shared/composables/stores/UserStore';
import {exportUserSession, globalFetchOptions} from '~/modules/shared/composables/utils/Helpers';

export const useSessionStore = defineStore(
  'session',
  () => {
    const router = useRouter();
    const config = useRuntimeConfig();
    const useUser = useUserStore();

    const defaultSessionDuration = config.public.sessionDuration ? parseInt(config.public.sessionDuration as string) : 30;

    const isIdle = ref(false);
    const timer = ref(defaultSessionDuration);
    const togglePopup = ref(false);
    const timerActive = ref(false);
    const sessionDuration = ref(defaultSessionDuration);
    const sessionTimeout = ref(add(new Date(), { seconds: sessionDuration.value }).getTime());

    const logout = () => {
      const cookie = exportUserSession();
      const config = useRuntimeConfig();
      return $fetch<{ success: boolean; data: { sessionDuration: number } }>(`/legacy/auth/logout`, {
        baseURL: config.public.legacyApiBase,
        headers: {
          Authorization: `Bearer ${cookie.value}`,
        },
        method: 'POST',
      });
    };

    const extendSession = () => {
      return $fetch<{ success: boolean; data: { token: string } }>(`/core-user/extend-session`, {
        ...globalFetchOptions(),
        method: 'GET',
      });
    };

    const destroyUserSession = (): void => {
      localStorage.removeItem('user-token');
    };

    const setIsIdle = (value: boolean) => {
      isIdle.value = value;
    };

    const resetTimer = (value = defaultSessionDuration) => {
      sessionDuration.value = value;
      sessionTimeout.value = add(new Date(), { seconds: sessionDuration.value }).getTime();
      localStorage.setItem('sessionTimeout', `${sessionTimeout.value}`);
      togglePopup.value = false;
      timer.value = value;
    };

    const extend = async () => {
      /*const resp = await extendSession();
      if (!resp.success) {
        await timeout();
      } else {
        localStorage.setItem('user-token', resp?.data?.token);
        resetTimer();
      }*/
      resetTimer();
    };

    const timeInterval = ref();
    const startCountdownTimer = () => {
      if (!timeInterval.value) {
        timerActive.value = true;
        timeInterval.value = setInterval(() => {
          timer.value -= 1;
          const now = new Date();
          // const thirtySecondsFromTimeout = sub(sessionTimeout.value, { seconds: 30 });
          const cookieSessionTimeout = parseInt(localStorage.getItem('sessionTimeout') ?? '0');
          const fiveMinsFromTimeout = sub(cookieSessionTimeout, { seconds: 300 });
          if (isAfter(now, fiveMinsFromTimeout)) {
            togglePopup.value = true;
          }
        }, 1000);
      }
    };

    const stopCountdownTimer = () => {
      timerActive.value = false;
      togglePopup.value = false;
      clearInterval(timeInterval.value);
      timeInterval.value = null;
    };

    const timeout = async () => {
      stopCountdownTimer();
      destroyUserSession();

      const isTsammUser = useUser.currentUser?.isTsammUser;
      useUser.clearUser();

      if (isTsammUser) {
      if (
        typeof config.public.sessionTimeoutRedirectURL === 'string' &&
        config.public.sessionTimeoutRedirectURL.startsWith('/')
      ) {
        await router.push(config.public.sessionTimeoutRedirectURL ?? '');
        return;
      } else {
        window.location.href = config.public.sessionTimeoutRedirectURL as string;
        return;
      }  
      } else {
        window.location.href = config.public.publicBaseUrl as string;
        return;
      }
      
    };

    const logoutSession = async () => {
      // await logout();
      await timeout();
    };

    const setTogglePopup = (value: boolean) => {
      togglePopup.value = value;
    };

    const isLoading = ref(false);
    const setLoading = (value: boolean) => {
      isLoading.value = value;
    };

    const expandAll = ref(false);
    const setExpandAllDefaultVal = () => {
      expandAll.value = false;
    };
    const toggleExpandAll = () => {
      expandAll.value = !expandAll.value;
    };

    return {
      isIdle,
      setIsIdle,
      togglePopup,
      setTogglePopup,
      timer,
      resetTimer,
      startCountdownTimer,
      stopCountdownTimer,
      timerActive,
      extend,
      timeout,
      sessionTimeout,
      logoutSession,
      isLoading,
      setLoading,
      expandAll,
      toggleExpandAll,
      setExpandAllDefaultVal,
      destroyUserSession,
    };
  },
  {
    persist: true,
  }
);
